import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Pricing.css";
import LoginModal from "./LoginModal";
import logoApp from "../assets/logo-app.png";
import iconMail from "../assets/icon-mail.svg";
import iconThreads from "../assets/icon-threads.svg";
import iconFacebook from "../assets/icon-facebook.svg";
import iconInstagram from "../assets/icon-instagram.svg";

const Pricing = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <div className="pricing-page">
      {/* Navigation Bar */}
      <nav className="landing-nav">
        <div className="nav-container">
          <div className="nav-brand">
            <img src={logoApp} alt="Runstreak Dashboard" className="nav-logo" />
            <span className="nav-brand-text">Runstreak Dashboard</span>
          </div>
          <div className="nav-menu">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/pricing" className="nav-link">Pricing</Link>
            <Link to="/help" className="nav-link">Help</Link>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-outlined">Login</button>
            <button onClick={() => setShowLoginModal(true)} className="nav-link nav-link-primary">Get Started</button>
          </div>
        </div>
      </nav>

      {/* Login Modal */}
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />

      <div className="pricing-container">
        <div className="pricing-header">
          <h1>Simple, Transparent Pricing</h1>
          <p className="pricing-subtitle">
            Runstreak Dashboard is completely free to use. No hidden fees, no
            credit card required.
          </p>
        </div>

        <div className="pricing-card-container">
          <div className="pricing-card featured">

            <div className="pricing-price">
              <span className="price-amount">$0</span>
            </div>

            <div className="pricing-features">
              <h3>What's Included:</h3>
              <ul>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Unlimited activity tracking</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Current & longest streak tracking</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Strava integration & auto-sync</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Manual GPX/TCX uploads</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Detailed pace & split analysis</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Performance analytics & insights</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Friends & leaderboards</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>CSV data export</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Location geocoding for runs</span>
                </li>
                <li>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="#10b981">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>No advertisements</span>
                </li>
              </ul>
            </div>

            <Link
              to="/"
              onClick={() => setShowLoginModal(true)}
              className="pricing-cta-button"
            >
              Get Started Free
            </Link>
          </div>
        </div>

        <div className="pricing-faq">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-item">
            <h3>Why is it free?</h3>
            <p>
              Runstreak Dashboard is a passion project built by runners, for
              runners. We believe that everyone should have access to powerful
              streak tracking tools without financial barriers.
            </p>
          </div>
          <div className="faq-item">
            <h3>Will it always be free?</h3>
            <p>
              Yes! We are committed to keeping all core features free forever. If
              we ever introduce premium features, the core streak tracking and
              activity management will remain free.
            </p>
          </div>
          <div className="faq-item">
            <h3>Do I need a credit card?</h3>
            <p>
              No credit card required. Simply sign up with your email or connect
              your Strava account to get started immediately.
            </p>
          </div>
          <div className="faq-item">
            <h3>Can I export my data?</h3>
            <p>
              Yes! You can export all your activity data to CSV format at any
              time. Your data belongs to you, and you can take it with you
              whenever you want.
            </p>
          </div>
          <div className="faq-item">
            <h3>How do you sustain the platform?</h3>
            <p>
              Currently, this is a self-funded project. We may explore optional
              donations or premium add-ons in the future, but the core platform
              will always remain free.
            </p>
          </div>
        </div>

        <div className="pricing-contact">
          <h2>Have More Questions?</h2>
          <p>
            We're here to help! Contact us at{" "}
            <a href="mailto:hello@runstreakdashboard.com">
              hello@runstreakdashboard.com
            </a>
          </p>
        </div>
      </div>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-brand">
              <img src={logoApp} alt="Runstreak Dashboard" className="brand-logo" />
              <span>Runstreak Dashboard</span>
            </div>
            <p>Keep your running streak alive with the most motivational fitness app.</p>
            <div className="social-links">
              <a href="#threads"><img src={iconThreads} alt="Threads" /></a>
              <a href="#facebook"><img src={iconFacebook} alt="Facebook" /></a>
              <a href="#instagram"><img src={iconInstagram} alt="Instagram" /></a>
            </div>
          </div>

          <div className="footer-column">
            <h4>Product</h4>
            <ul>
              <li><a href="/#features">Features</a></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><a href="#download">Download</a></li>
              <li><a href="#updates">Updates</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li><Link to="/help">Help Center</Link></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Contact Us</a></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Bug Reports</a></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Feature Requests</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><a href="mailto:hello@runstreakdashboard.com">Careers</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <p>© 2025 Runstreak. All rights reserved.</p>
          <div className="footer-contact">
            <img src={iconMail} alt="" />
            <a href="mailto:hello@runstreakdashboard.com">hello@runstreakdashboard.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Pricing;
